import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/shared/services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn:'root'
})
export class HomeInfoService {
  constructor(private http: HttpService) { }

  getToppersInfo(examId,examYear){
    const url = `courses/toppers?goalId=${examId}&goalYear=${examYear}&page=1&limit=1000`;
    return this.http.get(url, false, null, true, false,environment.serverURLv3);
  }

  getPreTrackerData(data){
    return this.http.post('getSubjectData', false, data, true, true,false,environment.serverURLv3);
  }

  getPreTrackerResult(data){
    return this.http.post('getResult', false, data, true, true,false,environment.serverURLv3);
  }
  
}